import script from "./Survey.vue?vue&type=script&setup=true&lang=ts"
export * from "./Survey.vue?vue&type=script&setup=true&lang=ts"

import "./Survey.vue?vue&type=style&index=0&id=b351de32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b351de32"]])

export default __exports__